import React from 'react';
import glamorous from 'glamorous';

const Text = glamorous.p({
  lineHeight: '1.3em',
  '& + &': {
    marginTop: '1rem',
  },
});

const TextBlock = ({
  children,
  style,
  className,
  component: Component = Text,
}) => {
  return (
    <div {...{ style, className }}>
      {children.split('\n').map((v, i) => <Component key={i}>{v}</Component>)}
    </div>
  );
};

export default TextBlock;



// WEBPACK FOOTER //
// ./src/common/components/TextBlock/index.js